import React, { FC, useState, useEffect, useContext } from 'react';

import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import CheckboxGroup from '../../../sharedModules/layout/CheckboxGroup';
import ErrorMessage from '../../../sharedModules/layout/ErrorMessage';
import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';

import { SnackBarContext } from '../../../sharedModules/form/contexts/SnackBarContext';
import { UsersContext } from '../contexts/UsersContext';

import axios from '../../../sharedModules/utils/axios.utils';

const NotificationsSection: FC = (props) => {
  const { setSnackBarOpen, setSnackBarMessage } = useContext(SnackBarContext);

  const { user, fetchUser } = useContext(UsersContext);

  const [isExpanded, setIsExpanded] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [notificationSettingIds, setNotificationSettingIds] = useState([]);
  const [settingOptions, setSettingOptions] = useState([]);

  const fetchNotificationSettingOptions = async () => {
    setLoading(true);
    try {
      const response: any = await axios.get('/pick_list_options', {
        params: { model: 'NotificationSetting' },
      });
      setSettingOptions(response.data.result);
      setErrorMessage('');
    } catch (error) {
      setErrorMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isExpanded && user.id) {
      fetchNotificationSettingOptions();
      setNotificationSettingIds(user.notification_setting_ids);
    }
  }, [isExpanded, user]);

  const handleUpdateSettings = async () => {
    setLoading(true);
    await axios.put(`/admin/users/${user.id}`, {
      user: { notification_setting_ids: notificationSettingIds },
    });

    setSnackBarOpen(true);
    setSnackBarMessage('Notification Settings Updated');
    setLoading(false);
    fetchUser(user.id);
    setIsExpanded(true);
  };

  return (
    <LoadingWrapper isLoading={loading}>
      <Accordion expanded={isExpanded} onChange={() => setIsExpanded(!isExpanded)}>
        <AccordionSummary>
          <Typography variant="h5" component="h5">
            Notification Settings
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ErrorMessage message={errorMessage} />
          <CheckboxGroup
            selectedIds={notificationSettingIds}
            setSelectedIds={setNotificationSettingIds}
            optionsList={settingOptions}
          />
          <Button variant="contained" color="primary" onClick={handleUpdateSettings} style={{ marginTop: '20px' }}>
            Update Notification Settings
          </Button>
        </AccordionDetails>
      </Accordion>
    </LoadingWrapper>
  );
};

export default NotificationsSection;
